import React from 'react';

import { useTranslation } from 'react-i18next';
import { Radio } from '@bringg/react-components';

import { ViewMode } from '../../types';

import styles from './form-controls.module.scss';

type Props = {
	viewMode: ViewMode;
	onViewModeChange: (mode: ViewMode) => void;
};

export const FormControls = ({ viewMode, onViewModeChange }: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.formControls}>
			<Radio.Group
				className={styles.formControlsRadioGroup}
				value={viewMode}
				onChange={e => onViewModeChange(e.target.value as ViewMode)}
			>
				<Radio className={styles.formControlsRadioGroupOption} value={ViewMode.allDays}>
					{t('RESERVE_CAPACITY.SAME_FOR_ALL_DAYS')}
				</Radio>
				<Radio className={styles.formControlsRadioGroupOption} value={ViewMode.perDay}>
					{t('RESERVE_CAPACITY.CONFIGURE_PER_DAY')}
				</Radio>
			</Radio.Group>
		</div>
	);
};
